import { trackFhhBannerClick } from 'shared/search/common/tracking';
import { Banner } from '../banner/Banner';

const bannerContent = {
    header: 'Har du et feriehjem som står og venter?',
    text: 'Enten det er hytte på fjellet eller leilighet i utlandet, er det mange som leter etter akkurat ditt sted på FINN. Det er enklere enn du tror å komme i gang, og jaggu er det lurt for lommeboka også.',
    callToAction: 'Start utleien her',
    link: 'https://www.finn.no/create-item/start/vertical/leisure',
    img: {
        src: 'https://images.finncdn.no/dynamic/1600w/travel/frontpage/nokler-trehytte-nokkelring.png?format=auto&fit=crop&width=470&height=350',
        width: 470,
        height: 350,
        alt: 'Nøkler med trehytte-nøkkelring',
        loading: 'lazy',
        decoding: 'async',
    },
} as const;

const handleBannerClick = () => trackFhhBannerClick(bannerContent.link);

export const FhhBanner = () => {
    const { header, text, callToAction, link, img } = bannerContent;

    return (
        <Banner header={header} text={text} callToAction={callToAction} link={link} imgType="img" img={img} onClick={handleBannerClick} />
    );
};
